export default __webpack_public_path__ + "c9270d3bbbd548c76d199fa7415c3507.svg";